import React, { useState } from "react";

const AuthContext = React.createContext({
  token: "",
  userName: "",
  email: "",
  imageUrl: "",
  isLoggedin: false,
  loginRequested: false,
  requestLogin: () => {},
  cancelLogin: () => {},
  login: (token, userName, imageUrl) => {},
  logout: () => {},
});

export const AuthContextProvider = (props) => {
  const [token, setToken] = useState(null);
  const [userName, setUserName] = useState(null);
  const [email, setEmail] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [loginRequested, setLoginRequested] = useState(false);
  const userIsLoggedin = !!token;

  const requestLoginHandler = () => {
    setLoginRequested(true);
  };

  const cancelLoginHandler = () => {
    setLoginRequested(false);
  };

  const loginHandler = (token, userName, email, imageUrl) => {
    setToken(token);
    setUserName(userName);
    setEmail(email);
    setImageUrl(imageUrl);
  };

  const logoutHandler = () => {
    setToken(null);
  };

  const contextValue = {
    token: token,
    userName: userName,
    email: email,
    imageUrl: imageUrl,
    isLoggedin: userIsLoggedin,
    loginRequested: loginRequested,
    requestLogin: requestLoginHandler,
    cancelLogin: cancelLoginHandler,
    login: loginHandler,
    logout: logoutHandler,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};
export default AuthContext;
